import { Component, ChangeDetectionStrategy, OnDestroy, OnInit } from '@angular/core';
import { DbService } from 'src/app/services/db.service';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ImageManagerService } from 'src/app/services/image-manager.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-pending-photos',
  templateUrl: './pending-photos.component.html',
  styleUrls: ['./pending-photos.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PendingPhotosComponent implements OnInit, OnDestroy {
  pendingGroups$: Observable<any[]>;
  private createdUrls: string[] = [];

  constructor(private db: DbService, private imageService: ImageManagerService, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.pendingGroups$ = from(
      Promise.all([
        this.db.getTableData('smart-pga', 'app_operation'),
        this.db.getTableData('smart-pga', 'app_pending_files')
      ])
    ).pipe(
      map(([operations, pendingFiles]) => {
        const groupsMap = new Map<string, { id_operation: any; photos: any[]; operation?: any }>();

        (pendingFiles || []).forEach(photo => {
          const idOperation = photo && photo.id_operation ? photo.id_operation : null;
          const key = JSON.stringify(idOperation);
          const blob = this.imageService.arrayBufferToBlob(photo.file, photo.type || 'image/jpeg');
          const previewUrl = URL.createObjectURL(blob);
          this.createdUrls.push(previewUrl);
          const safeUrl = this.sanitizer.bypassSecurityTrustUrl(previewUrl);
          if (!groupsMap.has(key)) {
            groupsMap.set(key, { id_operation: idOperation, photos: [] });
          }
          groupsMap.get(key).photos.push({ ...photo, previewUrl, displayUrl: safeUrl });
        });

        const groups = Array.from(groupsMap.values()).map(group => {
          const operation = (operations || []).find(op => JSON.stringify(op.id) === JSON.stringify(group.id_operation)) || null;
          return { ...group, operation };
        });

        return groups;
      })
    );
  }

  onImageError(event: any) {
    event.target.style.display = 'none';
    const parent = event.target.parentElement;
    if (parent) {
      parent.innerHTML = `
        <div class="image-error">
          <mat-icon>broken_image</mat-icon>
          <span>Immagine non disponibile</span>
        </div>
      `;
    }
  }

  ngOnDestroy(): void {
    if (this.createdUrls.length > 0) {
      this.createdUrls.forEach(url => {
        try { URL.revokeObjectURL(url); } catch {}
      });
      this.createdUrls = [];
    }
  }
}


